import React, { createContext, useCallback, useContext, useRef } from 'react';
import { Portal as ArkPortal, type PortalProps } from '@ark-ui/react/portal';
import { EnvironmentProvider } from '@ark-ui/react/environment';

export const PortalContainerContext = createContext<
  React.RefObject<HTMLElement | null> | undefined
>(undefined);

export const ScopedPortalProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const ref = useRef<HTMLDivElement>(null);

  // Stabilní reference — EnvironmentProvider hodnotu porovnává identitou,
  // nová funkce při každém renderu by zbytečně přerenderovávala konzumenty.
  const getRootNode = useCallback(
    () => ref.current?.ownerDocument ?? document,
    [],
  );

  return (
    <EnvironmentProvider value={getRootNode}>
      <PortalContainerContext.Provider value={ref}>
        <div style={{ position: 'relative', width: '100%', minHeight: '100%' }}>
          {children}

          <div
            ref={ref}
            className="penta-portal-root"
            style={{
              position: 'absolute',
              inset: 0,
              pointerEvents: 'none',
              zIndex: 10000,
            }}
          />
          {/* :where() drží specificitu na nule — pravidlo jen obnovuje
              klikatelnost po `pointer-events: none` na kontejneru a nesmí
              přebít styly komponent (např. Drawer positioner). */}
          <style
            dangerouslySetInnerHTML={{
              __html: `:where(.penta-portal-root > *) { pointer-events: auto; }`,
            }}
          />
        </div>
      </PortalContainerContext.Provider>
    </EnvironmentProvider>
  );
};

export const Portal: React.FC<React.PropsWithChildren<PortalProps>> = ({
  children,
  ...props
}) => {
  const container = useContext(PortalContainerContext);
  return (
    <ArkPortal container={container} {...props}>
      {children}
    </ArkPortal>
  );
};
